import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RUTAS_BITACORAS, RUTAS_INCIDENCIAS } from "../Rutas";
import LayoutGeneral from "../LayoutGeneral";
import "./Incidencias.css";
import DatePicker from "react-datepicker";

const Incidencias = () => {
    const navigate = useNavigate();
    const [inicidencias, setIncidencias] = useState([]);
    const [loading, setLoading] = useState(true);
    // Restaurar filtros desde sessionStorage si existen
    const [filtroNombre, setFiltroNombre] = useState(() => {
        try { return sessionStorage.getItem('filtroNombre') || ''; } catch (e) { return ''; }
    });
    const [filtroIncidencia, setFiltroIncidencia] = useState(() => {
        try { return sessionStorage.getItem('filtroIncidencia') || ''; } catch (e) { return ''; }
    });
const [filtroFechaInicio, setFiltroFechaInicio] = useState(() => {
  return sessionStorage.getItem("filtroFechaInicio") || "";
});

const [filtroFechaFin, setFiltroFechaFin] = useState(() => {
  return sessionStorage.getItem("filtroFechaFin") || "";
});

    const [filtroEstatus, setFiltroEstatus] = useState(() => {
        try { return sessionStorage.getItem('filtroEstatus') || ''; } catch (e) { return ''; }
    });
    const [oficinas, setOficinas] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [tipoIncidencia, setTipoIncidencia] = useState([]);
    const [mostrarFiltros, setMostrarFiltros] = useState(false);
    const admin = localStorage.getItem("admin");
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    const rolUsuario = roles.length > 0 ? roles[0].idRol : null;
    const puedeVerReporte = roles.some(role => role.idRol === 1 || role.idRol === 2 || role.idRol === 3);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');

    // Persistir filtros en sessionStorage cuando cambian
    useEffect(() => {
  try {
    sessionStorage.setItem("filtroNombre", filtroNombre);
    sessionStorage.setItem("filtroIncidencia", filtroIncidencia);
    sessionStorage.setItem("filtroFechaInicio", filtroFechaInicio);
    sessionStorage.setItem("filtroFechaFin", filtroFechaFin);
    sessionStorage.setItem("filtroEstatus", filtroEstatus);
  } catch (e) {
    console.error(e);
  }
}, [
  filtroNombre,
  filtroIncidencia,
  filtroFechaInicio,
  filtroFechaFin,
  filtroEstatus
]);

    useEffect(() => {
        const fetchIncidencias = async () => {
            try {
                const idUsuario = localStorage.getItem("idUsuario");
                const res = await fetch(RUTAS_INCIDENCIAS.GET_INCIDENCIAS(idUsuario));
                const data = await res.json();
                setIncidencias(data);
                console.log(data);
            } catch (error) {
                console.error("Error al cargar bitácoras:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchIncidencias();
    }, []);

    useEffect(() => {
        const idUsuario = localStorage.getItem("idUsuario");
        // Oficinas
        fetch(RUTAS_BITACORAS.GET_OFICINAS(idUsuario, rolUsuario))
            .then(res => res.json())
            .then(data => setOficinas(data));
        // Agentes
        fetch(RUTAS_INCIDENCIAS.GET_EMPLEADOS(idUsuario))
            .then(res => res.json())
            .then(data => setEmpleados(data));
        // Actividades
        fetch(RUTAS_INCIDENCIAS.GET_TIPO_INCIDENCIA)
            .then(res => res.json())
            .then(data => setTipoIncidencia(data));
    }, []);
    const cerrarSesion = () => {
        localStorage.removeItem("usuario");
        navigate("/");
    };
    // Redireccionamientos
    const GoUsuarios = () => { navigate("/Usuarios"); };
    const GoNuevaIncidencia = () => navigate("/IncidenciaNueva");
    const GoIncidencias = () => { navigate("/Incidencias") };
const stringAFecha = (fecha) => {
  if (!fecha) return null;

  // Por si viene: 27/10/2026 12:00:00 a. m.
  const soloFecha = fecha.split(" ")[0];

  const partes = soloFecha.split("/");

  if (partes.length !== 3) return null;

  const dia = Number(partes[0]);
  const mes = Number(partes[1]) - 1;
  const anio = Number(partes[2]);

  const resultado = new Date(anio, mes, dia);

  return isNaN(resultado.getTime()) ? null : resultado;
};


const fechaAString = (fecha) => {
  if (!fecha) return "";

  const dia = String(fecha.getDate()).padStart(2, "0");
  const mes = String(fecha.getMonth() + 1).padStart(2, "0");
  const anio = fecha.getFullYear();

  return `${dia}/${mes}/${anio}`;
};
    const incidenciasFiltradas = inicidencias.filter((b) =>{
        const fechaInicioIncidencia = stringAFecha(b.fechaInicio);
        const fechaFinIncidencia = stringAFecha(b.fechaFin);
        // Convertir también los filtros de texto a Date
  const fechaInicioFiltro = stringAFecha(filtroFechaInicio);
  const fechaFinFiltro = stringAFecha(filtroFechaFin);
  const cumpleFechaInicio =
    !fechaInicioFiltro ||
    (fechaInicioIncidencia &&
      fechaInicioIncidencia >= fechaInicioFiltro);

  const cumpleFechaFin =
    !fechaFinFiltro ||
    (fechaFinIncidencia &&
      fechaFinIncidencia <= fechaFinFiltro);
        return(
        (filtroNombre === "" || b.nombre === filtroNombre) &&
        (filtroIncidencia === "" || b.tipoIncidencia === filtroIncidencia) &&
        cumpleFechaInicio &&

    cumpleFechaFin &&
        (filtroEstatus === "" || String(b.estatus) === filtroEstatus)
    )});

    const handleDescargarExcel = async () => {
        const idUsuario = localStorage.getItem('idUsuario');
        try {
            const response = await fetch(RUTAS_INCIDENCIAS.GET_INCIDENCIA_JEFE_EXCEL(idUsuario, fechaInicio, fechaFin));
            console.log("Status:", response.status);

            if (response.ok) {
                console.log('Archivo recibido, iniciando descarga...' + idUsuario + ' - ' + fechaFin);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'reporte_incidencias.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } else {
                alert('Error al descargar el reporte');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error de conexión');
        }
    };

    return (
        <LayoutGeneral titulo="Incidencias">
            <div className="home-container">
                <aside className="sidebar">
                    <ul>
                        <li onClick={() => navigate("/Home")}><i className="bi bi-house"></i> Inicio</li>
                        {admin == 1 && (
                            <>
                                <li onClick={GoUsuarios}><i className="bi bi-people"></i> Usuarios</li>
                                
                            </>
                        )}
                        {puedeVerReporte && (
                            <li onClick={GoIncidencias}><i className="bi bi-people"></i> Incidencias</li>
                        )}
                        <li onClick={() => navigate("/Bitacoras")}><i className="bi bi-journal"></i> Bitácoras</li>
                        <li className="logout" onClick={() => { cerrarSesion(); }}>
                            <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
                        </li>
                    </ul>
                </aside>

                <main className="main-content">
                    <div className="d-flex align-items-center mb-3">
                        <h2 className="mb-0">Incidencias</h2>
                        <button
                            type="button"
                            className={`filtro-toggle btn-sm ms-3${mostrarFiltros ? " active" : ""}`}
                            onClick={() => setMostrarFiltros(!mostrarFiltros)} title="Mostrar/Ocultar filtros" >
                            <i className="bi bi-funnel-fill"></i> Filtros
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary btn-nueva-bitacora ms-20"
                            onClick={GoNuevaIncidencia} style={{ marginLeft: "auto" }} >
                            <i className="bi bi-plus-lg"></i> Nueva Incidencia
                        </button>
                        {puedeVerReporte && (
                            <button type="button" className="btn btn-success ms-2 rounded btn-descargar" data-bs-toggle="modal" data-bs-target="#modalDescargar">
                                <i className="bi bi-file-earmark-excel"></i> Descargar Reporte
                            </button>
                        )}
                    </div>

                    {mostrarFiltros && (
                        <div className="filtros-container p-3 mb-4 rounded shadow-sm">
                            {/* Filtros */}
                            <div className="row align-items-end">
                                <div className="col-md-3 mb-2">
                                    <label className="filtro-label">Nombre</label>
                                    <select className="form-control filtro-select" value={filtroNombre} onChange={e => setFiltroNombre(e.target.value)} >
                                        <option value="">Todos</option>
                                        {empleados.map(a => (
                                            <option key={a.idUsuario} value={a.nombre}>
                                                {a.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="filtro-label">Tipo Incidencias</label>
                                    <select className="form-control filtro-select" value={filtroIncidencia} onChange={e => setFiltroIncidencia(e.target.value)} >
                                        <option value="">Todas las actividades</option>
                                        {tipoIncidencia.map(act => (
                                            <option key={act.idIncidencia} value={act.incidencia}>
                                                {act.incidencia}
                                            </option>
                                        ))}
                                    </select>
                                </div>
<div className="col-md-2 mb-2">
  <label className="filtro-label">Fecha Inicio</label>

  <DatePicker
    selected={stringAFecha(filtroFechaInicio)}
    onChange={(date) => {
      setFiltroFechaInicio(fechaAString(date));
    }}
    className="form-control"
    dateFormat="dd/MM/yyyy"
    placeholderText="Fecha inicio"
    isClearable
  />
</div>
<div className="col-md-2 mb-2">
  <label className="filtro-label">Fecha Fin</label>

  <DatePicker
    selected={stringAFecha(filtroFechaFin)}
    onChange={(date) => {
      setFiltroFechaFin(fechaAString(date));
    }}
    className="form-control"
    dateFormat="dd/MM/yyyy"
    placeholderText="Fecha fin"
    isClearable
    minDate={stringAFecha(filtroFechaInicio)}
  />
</div>

                                <div className="col-md-3 mb-2">
                                    <label className="filtro-label">Estatus</label>
                                    <select className="form-control filtro-select" value={filtroEstatus} onChange={e => setFiltroEstatus(e.target.value)} >
                                        <option value="">Todos</option>
                                        <option value="1">Aprobadas</option>
                                        <option value="0">Canceladas</option>
                                    </select>
                                </div>
                            </div>
                            <hr className="my-3" />
                        </div>
                    )}

                    {loading ? (
                        <p>Cargando incidencias...</p>
                    ) : incidenciasFiltradas.length > 0 ? (
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Editar</th>
                                    <th>ID</th>
                                    <th>Nombre</th>
                                    <th>Incidencia</th>
                                    <th>Fecha Inicio</th>
                                    <th>Fecha Fin</th>
                                    <th>Estatus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {incidenciasFiltradas.map((b) => (
                                    <tr key={b.idIncidencia}>
                                        <td>
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => navigate(`/Incidencia_Seguimiento/${b.idIncidencia}`)}
                                            >
                                                <i className="bi bi-pencil-square"></i>
                                            </button>
                                        </td>
                                        <td>{b.idIncidencia}</td>
                                        <td>
                                            {b.nombre
                                                ? b.nombre.length > 30
                                                    ? b.nombre.substring(0, 30) + " ..."
                                                    : b.nombre
                                                : "N/A"}
                                        </td>
                                        <td>{b.tipoIncidencia}</td>
                                        <td>{b.fechaInicio.split(" ")[0]}</td>
                                        <td>{b.fechaFin.split(" ")[0]}</td>
                                        <td>{Number(b.estatus) === 1 ? "Aprobada" : "Cancelada"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="alert alert-info">No hay incidencias registradas.</div>
                    )}
                </main>
            </div>

            {/* Modal para descargar reporte */}
            <div className="modal fade" id="modalDescargar" tabIndex="-1" aria-labelledby="modalDescargarLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modalDescargarLabel">Descargar Reporte de Incidencias</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="fechaInicio" className="form-label">Fecha Inicio</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fechaInicio"
                                    value={fechaInicio}
                                    onChange={(e) => setFechaInicio(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="fechaFin" className="form-label">Fecha Fin</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fechaFin"
                                    value={fechaFin}
                                    onChange={(e) => setFechaFin(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => { handleDescargarExcel(); setFechaInicio(''); setFechaFin(''); }} data-bs-dismiss="modal">Descargar</button>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutGeneral>
    );
};

export default Incidencias;
